import _ from 'lodash';
import { stageAddition } from '../helpers';

const coef = (y, x) => (_.sum(x.map((x_y, index) => x_y * y[index]))) / (_.sum(x.map(i => i * i)));
const residual = (a, b, c) => a.map((i, index) => i - b[index] * c);

function polynomialSeries(data) {
  let normalSeries = [], logSeries = [], errors = [];

  let x = data.map(item => item[0]);
  let y = data.map(item => item[1]);
  let one = data.map(() => 1);
  let x2 = x.map(i => i * i);

  let beta_x_1 = coef(x, one);
  let beta_x2_1 = coef(x2, one);
  let beta_y_1 = coef(y, one);

  let res_x_1 = residual(x, one, beta_x_1);
  let res_x2_1 = residual(x2, one, beta_x2_1);
  let res_y_1 = residual(y, one, beta_y_1);

  let beta_x2_1_x = coef(res_x2_1, res_x_1);
  let beta_y_1_x = coef(res_y_1, res_x_1);

  let res_x2_1_x = residual(res_x2_1, res_x_1, beta_x2_1_x);
  let res_y_1_x = residual(res_y_1, res_x_1, beta_y_1_x);

  let beta_y_1_x_x2 = coef(res_y_1_x, res_x2_1_x);

  let beta_2 = beta_y_1_x_x2;
  let beta_1 = beta_y_1_x - beta_2 * beta_x2_1_x;
  let beta_0 = beta_y_1 - beta_y_1_x * beta_x_1 - beta_y_1_x_x2 * (beta_x2_1 - beta_x2_1_x * beta_x_1);

  // console.log(beta_x_1, beta_x2_1, beta_y_1)
  // console.log(beta_x2_1_x, beta_y_1_x);
  // console.log(beta_2, beta_1, beta_0)

  let min_x = _.min(x);
  let max_x = _.max(x);
  let i = min_x;
  let dataMapping = data.map(item => ({ [item[0]]: item[1] }));
  while (i <= max_x) {
    let
      x = i,
      X = Math.log(x),
      y = beta_0 + beta_1 * x + beta_2 * x * x,
      Y = Math.log(y);

    // if (!!dataMapping[x]) {
    //   errors.push((dataMapping[x] - y) ** 2);
    // }
    let all_obs_for_x = data.filter(item => +item[0] === +x);
    all_obs_for_x.forEach(obs_data => {
      let obs_y = obs_data[1];
      let Y_ = Math.log(obs_y);
      errors.push((obs_y - y) ** 2);
    });

    normalSeries.push([x, y]);
    logSeries.push([X, Y]);
    i = stageAddition(i);
  }

  return {
    normalSeries,
    logSeries,
    parameters: {
      a: beta_0, b: beta_1, c: beta_2, rmse: Math.sqrt(_.mean(errors))
    }
  };
}

export default polynomialSeries;


// WEBPACK FOOTER //
// ./src/components/Hydrology/RTEquations/scripts/polynomial.js